import { render, staticRenderFns } from "./LabSettingsView.vue?vue&type=template&id=5ee7faad&scoped=true&"
import script from "./LabSettingsView.vue?vue&type=script&lang=js&"
export * from "./LabSettingsView.vue?vue&type=script&lang=js&"
import style0 from "./LabSettingsView.vue?vue&type=style&index=0&id=5ee7faad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee7faad",
  null
  
)

export default component.exports